import React from 'react';

const Icon = () => (
  <g>
    <rect
      x="1.5"
      y="1.5"
      width="17"
      height="17"
      rx="3.5"
      fill="#E8E9EB"
      stroke="#A5AAAF"
      transform="translate(2 2)"
    />
  </g>
);

export default Icon;
